export const API_ROOT_URL = 'https://api.visceralapps.com'
export const API_URL = 'https://api.visceralapps.com/api'
export const APP = 'consignment'
export const PARAMS = {}
export const API_KEY = '403324901671043924b52ffa719a59ad'



// WEBPACK FOOTER //
// ./src/localSettings.js